import React from 'react';
import { AppRouter } from './routes/AppRouter';
import './styles/styles.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <CookiesProvider>
        <AppRouter />
      </CookiesProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
